import { withStyles } from "@material-ui/styles";
import ReactPhoneInput from "react-phone-number-input/max";
import "react-phone-number-input/style.css";
import styles from "./phoneInput.style";
import React, { useEffect, useMemo, useState } from "react";
import store from "Store";
import classNames from "classnames";
import Validation from "Common/Validation/Validation";
import { Field } from "react-final-form";

const { requiredPhone, isPossiblePhoneNumber, composeValidators } = Validation;

function PhoneInput({ name, value, change, classes, submitting }) {
    const country = store.getState().locale.country || "US";

    const [currentCountry, setCurrentCountry] = useState(country);
    const [isTouched, setIsTouched] = useState(false);
    const validate = composeValidators(requiredPhone, isPossiblePhoneNumber);

    useEffect(() => {
        setCurrentCountry(country);
    }, [country]);

    useEffect(() => {
        if (submitting) {
            setIsTouched(true);
        }
    }, [submitting]);

    const error = useMemo(() => {
        if (!isTouched) return null;
        return validate(value);
    }, [value, isTouched, name, submitting]);

    return (
        <div className={classes.container}>
            <div className={classNames(classes.wrapper, error && "error")}>
                <Field
                    name={name}
                    component={ReactPhoneInput}
                    type="input"
                    label="phone"
                    onChange={number => {
                        change(name, number || "");
                    }}
                    validate={validate}
                    data-testid="phone_number_input"
                    value={value}
                    id={name}
                    international
                    countryCallingCodeEditable={false}
                    onBlur={() => setIsTouched(true)}
                    onCountryChange={country => {
                        setCurrentCountry(country);
                    }}
                    smartCaret
                    defaultCountry={currentCountry}
                />
            </div>
            <div className={classes.error}>{error}</div>
        </div>
    );
}

export default withStyles(styles)(PhoneInput);



// WEBPACK FOOTER //
// ./src/components/StartContainer/components/PhoneInput.js